/**
 * Thanks — terminal landing once all 3 steps are complete.
 */

interface Props {
  navigate: (path: string) => void;
}

export default function Thanks({ navigate: _navigate }: Props) {
  return (
    <div className="bg-white dark:bg-slate-900 rounded-lg shadow-sm border border-slate-200 dark:border-slate-800 p-8 max-w-2xl mx-auto text-center">
      <div className="w-16 h-16 bg-green-100 dark:bg-green-900/40 rounded-full flex items-center justify-center mx-auto mb-6">
        <svg className="w-8 h-8 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h1 className="text-2xl font-semibold text-slate-900 dark:text-white mb-3">
        Thanks &mdash; we've got everything we need.
      </h1>
      <p className="text-slate-600 dark:text-slate-300 mb-2 max-w-md mx-auto">
        Our team will reach out within one business day to schedule your onboarding session.
      </p>
      <p className="text-slate-600 dark:text-slate-300 max-w-md mx-auto">
        Need to update something? Email us at{' '}
        <a href="mailto:support@oasisautokonnect.com" className="text-blue-600 dark:text-blue-400 hover:underline">
          support@oasisautokonnect.com
        </a>
        .
      </p>
    </div>
  );
}
